import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@/fontawesome';

interface FeatureBannerProps {
  featureName: string;
}

const FEATURE_NAMES: Record<string, string> = {
  coreRecommendations: 'Kernstrategie',
  earningRecommendations: 'Earnings Trades',
  swingTradeRecommendations: 'Swing Trades',
  longTermRecommendations: 'Langzeit Trades',
  chatbot: 'Trading-Buddy',
  videoChatbot: 'Video-Chatbot',
  journal: 'Trading-Journal',
  videoSearch: 'Video-Finder',
  allCourses: 'Alle Kurse'
};

export default function FeatureBanner({ featureName }: FeatureBannerProps) {
  const displayName = FEATURE_NAMES[featureName] || featureName;

  return (
    <div className="max-w-7xl mx-auto bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-6 mb-6">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-amber-100 dark:bg-amber-800/30 rounded-full">
            <FontAwesomeIcon
              icon={faLock}
              className="w-6 h-6 text-amber-600 dark:text-amber-400"
            />
          </div>
        </div>
        <div className="ml-4 flex-1">
          <h3 className="text-lg font-semibold text-amber-900 dark:text-amber-100 mb-2">
            Noch nicht freigeschaltet
          </h3>
          <p className="text-amber-800 dark:text-amber-200 mb-4">
            In diesem Bereich findest du alle aktiven Trades der {displayName} mit klaren Einstiegs- und Ausstiegsbereichen.
            Aktuell siehst du nur die kostenlosen Beispiele.
          <br/>
            <b>Mach den nächsten Schritt, um alle laufenden Setups zu sehen – inklusive Hintergrundanalyse, Logik und Marktbedingungen. </b>         </p>
          <Link
            to="/pricing"
            className="inline-block px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
          >
            Alle Setups freischalten
          </Link>
        </div>
      </div>
    </div>
  );
}
